import React from 'react';
import PropTypes from 'prop-types';
import { Col, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { icon } from '@fortawesome/fontawesome-svg-core/import.macro';
import { Link } from 'react-router-dom';

/**
 * Componente para mostrar y gestionar módulos asignados a licencias
 */
const ModulosAsignados = ({
    objLicenciasModulo,
    product,
    orden,
    obtenerLicenciasParaModulo
}) => {
    const yaHayLicenciaAsignada = objLicenciasModulo.some(l => l.idLicencia > 0);

    return (
        <>
            {objLicenciasModulo.map((objLicModulo, indexModulo) => {
                const keyModulo = objLicModulo.idLicencia > 0
                    ? `mod-${product.idOrdenDetalle}-${objLicModulo.idLicencia}`
                    : `mod-empty-${product.idOrdenDetalle}-${indexModulo}`;

                // Si tiene licencia asignada al módulo
                if (objLicModulo.idLicencia > 0) {
                    return (
                        <Col key={keyModulo} className="pr-1 mb-2" style={{ cursor: 'pointer' }}>
                            <Link
                                to={`/licencias/detalle/${objLicModulo.idLicencia}`}
                                target="_blank"
                                className="stretched-link text-info position-relative"
                            >
                                <img className="mr-2" src="/img/pcautorizada20.png" alt="" />
                                {product.vCodigoBarras} #{objLicModulo.idLicencia}
                            </Link>

                            {/* Badges de estado si existen */}
                            {objLicModulo.Status && (
                                <>
                                    {objLicModulo.Status === "NO ACTIVADA" ? (
                                        <span className="ms-2 badge badge-soft-danger">
                                            {objLicModulo.Status}
                                        </span>
                                    ) : objLicModulo.Status.includes("VC ") ? (
                                        <span className="ms-2 badge badge-soft-warning">
                                            {objLicModulo.Status}
                                        </span>
                                    ) : (
                                        <span className="ms-2 badge badge-soft-success">
                                            {objLicModulo.Status}
                                        </span>
                                    )}
                                </>
                            )}

                            {objLicModulo.bCancelado === 1 && (
                                <>
                                    &nbsp;
                                    <span className="ms-2 badge badge-soft-danger">CANCELADA</span>
                                </>
                            )}
                        </Col>
                    );
                }

                // Si no hay licencia asignada pero ya hay otra asignada en el array - no mostrar botón
                if (yaHayLicenciaAsignada) return null;

                // ModuloExtra: la asignación es automática vía webhook, no se asigna manualmente
                if (product.vTipoProducto === 'ModuloExtra') return null;

                // Si no hay licencia asignada - Mostrar botón para asignar
                return (
                    <Col key={keyModulo} className="pr-1 mb-2">
                        <div
                            className="d-flex align-items-center"
                            style={{ cursor: 'pointer' }}
                            onClick={() =>
                                obtenerLicenciasParaModulo(
                                    product.idProducto,
                                    product.idOrdenDetalle,
                                    orden.idClienteAkasia,
                                    product.vCodigoBarras,
                                    false
                                )
                            }
                        >
                            <OverlayTrigger
                                placement="bottom"
                                overlay={
                                    <Tooltip id="tooltip-renovacion">
                                        <strong>Asignar licencia a módulo</strong>
                                    </Tooltip>
                                }
                            >
                                <span className="d-flex align-items-center">
                                    <FontAwesomeIcon
                                        className="me-2"
                                        icon={icon({ name: 'file-contract', style: "solid" })}
                                        style={{ color: "#28a745" }}
                                        size="xl"
                                    />
                                    <span className="text-muted" style={{ fontSize: '0.875rem' }}>
                                        Click para <strong>asignar licencia a módulo</strong>
                                    </span>
                                </span>
                            </OverlayTrigger>
                        </div>
                    </Col>
                );
            })}
        </>
    );
};

ModulosAsignados.propTypes = {
    objLicenciasModulo: PropTypes.array.isRequired,
    product: PropTypes.object.isRequired,
    orden: PropTypes.object.isRequired,
    obtenerLicenciasParaModulo: PropTypes.func.isRequired
};

export default ModulosAsignados;
